import { onValue, orderByChild, query, set } from 'firebase/database';
import {
  FETCH_DOCUMENT_FIELDS,
  FETCH_DOCUMENT_FIELDS_SUCCESS,
  FETCH_DOCUMENT_FIELDS_FAILED,
  UPDATE_DOCUMENT_FIELDS,
} from '../store/types';
import { firebase } from '../config/configureFirebase';

export const fetchDocumentFields = () => (dispatch) => {
  try {
    const {
      documentFieldRef
    } = firebase;

    if (!documentFieldRef) {
      console.error("Firebase documentFieldRef is not properly initialized");
      dispatch({
        type: FETCH_DOCUMENT_FIELDS_FAILED,
        payload: "Firebase reference not initialized"
      });
      return;
    }

    dispatch({
      type: FETCH_DOCUMENT_FIELDS,
      payload: null
    });

    onValue(query(documentFieldRef, orderByChild('created_at')), (snapshot) => {
      const data = snapshot.val();
      if (data) {
        const sortedData = Object.entries(data)
          .sort(([, a], [, b]) => (b.created_at || 0) - (a.created_at || 0))
          .reduce((r, [k, v]) => ({ ...r, [k]: v }), {});

        dispatch({
          type: FETCH_DOCUMENT_FIELDS_SUCCESS,
          payload: sortedData
        });
      } else {
        dispatch({
          type: FETCH_DOCUMENT_FIELDS_FAILED,
          payload: "Unable to fetch document field settings."
        });
      }
    }, (error) => {
      dispatch({
        type: FETCH_DOCUMENT_FIELDS_FAILED,
        payload: error.message
      });
    });
  } catch (error) {
    console.error("fetchDocumentFields error:", error);
    dispatch({
      type: FETCH_DOCUMENT_FIELDS_FAILED,
      payload: error.message
    });
  }
};

export const updateDocumentFields = (
  data,
  onSuccess,
  onError
) => (dispatch) => {
  try {
    const {
      documentFieldEditRef
    } = firebase;

    if (!documentFieldEditRef) {
      onError();
      return;
    }

    dispatch({
      type: UPDATE_DOCUMENT_FIELDS,
      payload: data
    });

    set(documentFieldEditRef(data.id), data);
    onSuccess();
  } catch (error) {
    onError();
  }
}; 